/* istanbul ignore file */
import { useCallback, useState } from 'react';
export const useMaybeState = (initValue) => {
    const [maybeState, setMaybeState] = useState(initValue);
    const clearState = useCallback(() => setMaybeState(null), []);
    return [maybeState, setMaybeState, clearState];
};
//# sourceMappingURL=useMaybeState.js.map